import React from 'react';
import styled from 'styled-components';

interface NotFoundProps {
	buttonLabel: string;
	redirect: string;
}

export default function NotFound(props: NotFoundProps) {
	const { buttonLabel, redirect } = props;
	return (
		<Container className="container">
			<div className="row">
				<div className="col-xs-12">
					<Card>
						<Icon className="fas fa-compass" aria-hidden />
						<h1>Page not found</h1>
						<p>The page you are looking for doesn&apos;t exist or may have moved.</p>
						<a className="btn btn-primary" href={redirect}>
							{buttonLabel}
						</a>
					</Card>
				</div>
			</div>
		</Container>
	);
}

const Container = styled.div`
	min-height: calc(var(--vh, 1vh) * 100 - 60px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Card = styled.div`
	background: #ffffff;
	border: 1px solid #e6e8eb;
	border-radius: 12px;
	padding: 2rem;
	text-align: center;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);

	h1 {
		margin: 0.75rem 0 0.5rem;
		font-weight: 700;
	}

	p {
		color: #6c757d;
		margin-bottom: 1.5rem;
	}
`;

const Icon = styled.i`
	font-size: 2.5rem;
	color: #2f7ed9;
`;
